import { FC, HTMLAttributes } from "react";
import clx from "classnames";
import st from "./Link.module.scss";

interface ILinkProps extends HTMLAttributes<HTMLElement> {
	href?: string;
};

const Link: FC<ILinkProps> = ( { href, children, className, ...otherProps } ) => {

	if ( !href ) return (
		<span className={clx(st.link, className)} {...otherProps}>
			{children}
		</span>
	);
	else return (
		<a href={href} className={clx(st.link, className)} {...otherProps}>
			{children}
		</a>
	);
};

export default Link;
